export const REQUEST_ERROR = 'ERROR';
export const REQUEST_PENDING = 'PENDING';
export const REQUEST_SUCCESS = 'SUCCESS';

export const REQUEST_LOGIN_ID: string = 'REQUEST_LOGIN_ID';
export const REQUEST_RENEW_ID: string = 'REQUEST_RENEW_ID';
export const REQUEST_PASSWORD_CHANGE_ID: string = 'REQUEST_PASSWORD_CHANGE_ID';
export const REQUEST_LOGOUT_ID: string = 'REQUEST_LOGOUT_ID';

export const REQUEST_REGISTRATION_VERIFY_CODE: string = 'REQUEST_REGISTRATION_VERIFY_CODE';
export const REQUEST_REGISTRATION_SET_PASSWORD: string = 'REQUEST_REGISTRATION_SET_PASSWORD';

export const REQUEST_CARDS_STATS_ID: string = 'REQUEST_CARDS_STATS_ID';
export const REQUEST_CARDS_LIST_ID: string = 'REQUEST_CARDS_LIST_ID';
export const REQUEST_CARDS_VIEW_ID: string = 'REQUEST_CARDS_VIEW_ID';
export const REQUEST_CARDS_TRANSFER_TO_CRM_ID: string = 'REQUEST_CARDS_TRANSFER_TO_CRM_ID';
export const REQUEST_CARDS_LINK_CREATE_ID: string = 'REQUEST_CARDS_LINK_CREATE_ID';

export const REQUEST_CREDIT_LIST_ID: string = 'REQUEST_CREDIT_LIST_ID';
export const REQUEST_CREDIT_VIEW_ID: string = 'REQUEST_CREDIT_VIEW_ID';
export const REQUEST_CREDIT_NEW_ID: string = 'REQUEST_CREDIT_NEW_ID';
export const REQUEST_CREDIT_PREVIOUS_ID: string = 'REQUEST_CREDIT_PREVIOUS_ID';
export const REQUEST_CREDIT_PREVIOUS_VIEW_ID: string = 'REQUEST_CREDIT_PREVIOUS_VIEW_ID';
export const REQUEST_CREDIT_OPTIONS_ID: string = 'REQUEST_CREDIT_OPTIONS_ID';
export const REQUEST_CREDIT_UPDATE_ID: string = 'REQUEST_CREDIT_UPDATE_ID';
export const REQUEST_CREDIT_UPDATE_PROPERTY_ID: string = 'REQUEST_CREDIT_UPDATE_PROPERTY_ID';
export const REQUEST_CREDIT_UPDATE_MULTIPLE_PROPERTIES_ID: string = 'REQUEST_CREDIT_UPDATE_MULTIPLE_PROPERTIES_ID';
export const REQUEST_CREDIT_REQUEST_ID: string = 'REQUEST_CREDIT_REQUEST_ID';
export const REQUEST_CREDIT_STATUS_CHANGE_ID: string = 'REQUEST_CREDIT_STATUS_CHANGE_ID';
export const REQUEST_CREDIT_DOWNLOAD_ID: string = 'REQUEST_CREDIT_DOWNLOAD_ID';
export const REQUEST_CREDIT_LOCK_ID: string = 'REQUEST_CREDIT_LOCK_ID';
export const REQUEST_CREDIT_UNLOCK_ID: string = 'REQUEST_CREDIT_UNLOCK_ID';
export const REQUEST_CREDIT_POSTPONE_INSTALLMENT_ID: string = 'REQUEST_CREDIT_POSTPONE_INSTALLMENT_ID';
export const REQUEST_CREDIT_ATTACHMENT_LIST_ID: string = 'REQUEST_CREDIT_ATTACHMENT_LIST_ID';
export const REQUEST_CREDIT_ATTACHMENT_UPLOAD_ID: string = 'REQUEST_CREDIT_ATTACHMENT_UPLOAD_ID';
export const REQUEST_CREDIT_ATTACHMENT_UPDATE_ID: string = 'REQUEST_CREDIT_ATTACHMENT_UPDATE_ID';
export const REQUEST_CREDIT_ATTACHMENT_DELETE_ID: string = 'REQUEST_CREDIT_ATTACHMENT_DELETE_ID';
export const REQUEST_CREDIT_ATTACHMENT_TYPE_NEW_ID: string = 'REQUEST_CREDIT_ATTACHMENT_TYPE_NEW_ID';
export const REQUEST_CREDIT_ATTACHMENT_TYPE_DELIVERED_ID: string = 'REQUEST_CREDIT_ATTACHMENT_TYPE_DELIVERED_ID';
export const REQUEST_CREDIT_PAYMENT_CREATE_ID: string = 'REQUEST_CREDIT_PAYMENT_CREATE_ID';
export const REQUEST_CREDIT_PAYMENT_DELETE_ID: string = 'REQUEST_CREDIT_PAYMENT_DELETE_ID';
export const REQUEST_CREDIT_LINK_CREATE_ID: string = 'REQUEST_CREDIT_LINK_CREATE_ID';

export const REQUEST_PROFILES_LIST_ID: string = 'REQUEST_PROFILES_LIST_ID';

export const REQUEST_USER_RECOMMENDATION_STATS_ID: string = 'REQUEST_USER_RECOMMENDATION_STATS_ID';
export const REQUEST_USER_RECOMMENDATION_LIST_ID: string = 'REQUEST_USER_RECOMMENDATION_LIST_ID';
export const REQUEST_USER_RECOMMENDATION_TRANSFER_TO_CRM_ID: string = 'REQUEST_USER_RECOMMENDATION_TRANSFER_TO_CRM_ID_';

export const REQUEST_USERS_LIST_ID: string = 'REQUEST_USERS_LIST_ID';
export const REQUEST_USERS_CREATE_ID: string = 'REQUEST_USERS_CREATE_ID';
export const REQUEST_USERS_UPDATE_ID: string = 'REQUEST_USERS_UPDATE_ID';
export const REQUEST_USERS_CLIENTS_ID: string = 'REQUEST_USERS_CLIENTS_ID';
export const REQUEST_USERS_CLIENTS_MY_ID: string = 'REQUEST_USERS_CLIENTS_MY_ID';
export const REQUEST_USERS_CLIENTS_STATS_ID: string = 'REQUEST_USERS_CLIENTS_STATS_ID';
export const REQUEST_USERS_CLIENTS_VIEW_ID: string = 'REQUEST_USERS_CLIENTS_VIEW_ID';
export const REQUEST_USERS_CLIENTS_NEW_ID: string = 'REQUEST_USERS_CLIENTS_NEW_ID';
export const REQUEST_USERS_CLIENTS_UPDATE_PROPERTY_ID: string = 'REQUEST_USERS_CLIENTS_UPDATE_PROPERTY_ID';
export const REQUEST_USERS_CLIENTS_DELETE_ID: string = 'REQUEST_USERS_CLIENTS_DELETE_ID';
export const REQUEST_USER_CHANGE_PASSWORD: string = 'REQUEST_USER_CHANGE_PASSWORD';
export const REQUEST_USER_CHANGE_AVATAR: string = 'REQUEST_USER_CHANGE_AVATAR';
export const REQUEST_USER_COMMENTS_LIST_ID: string = 'REQUEST_USER_COMMENTS_LIST_ID';
export const REQUEST_USER_COMMENTS_CREATE_ID: string = 'REQUEST_USER_COMMENTS_CREATE_ID';
export const REQUEST_USER_AGENTS_LIST_ID: string = 'REQUEST_USER_AGENTS_LIST_ID';
export const REQUEST_USER_AGENT_CHANGE_ID: string = 'REQUEST_USER_AGENT_CHANGE_ID';

export const REQUEST_CHATS_LIST_ID: string = 'REQUEST_CHATS_LIST_ID';
export const REQUEST_CHATS_ONE_ID: string = 'REQUEST_CHATS_ONE_ID';
export const REQUEST_CHATS_MESSAGES_LIST_ID: string = 'REQUEST_CHATS_MESSAGES_LIST_ID';
export const REQUEST_CHATS_MESSAGES_READ_ID: string = 'REQUEST_CHATS_MESSAGES_READ_ID';
export const REQUEST_CHATS_MESSAGES_CREATE_ID: string = 'REQUEST_CHATS_MESSAGES_CREATE_ID';
export const REQUEST_CHATS_MESSAGES_ATTACHMENT_UPLOAD_ID: string = 'REQUEST_CHATS_MESSAGES_ATTACHMENT_UPLOAD_ID';

export const REQUEST_CONTROL_F1: string = 'REQUEST_CONTROL_F1';
export const REQUEST_CONTROL_F2: string = 'REQUEST_CONTROL_F2';
export const REQUEST_CONTROL_F3: string = 'REQUEST_CONTROL_F3';
export const REQUEST_CONTROL_F4: string = 'REQUEST_CONTROL_F4';